import functions from '../functions';
import { list } from './list';
import { Select2 } from "../components/select2";

$(() => {
    listTravel.init();
});

const listTravel = {
    $form: null,
    form: null,
    $filter: null,
    filter: null,
    defaults: {
        _page: 1,
        perPage: 10,
        language: functions.getLang(),
        arrivalDateFrom: '',
        destination: '',
        countryId: '',
        objectGroupId: 6,
        guests: '',
        hasArrival: 2,
        hasDiscount: null,
        tagCategoryId: '',
        tagCategoryIds: '',
        objectTypeId: '',
        shipId: '',
        linkedId: '',
        //sortBy: '2:DESC'
    },
    params: {},
    isHome: false,
    $listItems: null,
    filterParams: {
        tagCategoryId: '',
        //sortBy: null, 
        objectName: null,
        hasDiscount: null,
        objectTypeId: '',
    },
    filterParamDefaults: {
        tagCategoryId: '',
        transportationType: '',
        objectName: null,
        hasDiscount: null,
        objectTypeId: '',
    },
    mainFields: ['arrivalDateFrom', 'destination', 'sortBy'],
    init() {
        this.$form = $('.search-form.search-travel');
        this.form = this.$form[0];

        if(! this.form || this.defaults.objectGroupId != this.$form.attr('data-objectgroupid')) {
            return;
        }

        this.$filter = $('.search-filter');
        this.filter = this.$filter[0];  

        this.$listItems = $('.list-items');
        this.isHome = this.$form.last().attr('data-ishome') || ! this.$listItems.length;

        this.listURL = this.$form.last().attr('data-listurl');
        this.defaults.objectGroupId = this.$form.last().attr('data-objectgroupid');
        this.defaults.transportationType = this.$form.attr('data-transportationtype');
        this.defaults.tagCategoryId = this.$form.attr('data-tagCategoryId') || '';
        // debugger

        // OLD
        // this.defaults.countryId = this.defaults.destination = this.$form.last().attr('data-countryid');

        this.defaults.destination = this.$form.attr('data-destination') ? this.$form.attr('data-destination') : this.defaults.countryId;

        this.$filter = $('.search-filter');

        this.filterParams.tagCategoryId = this.$form.last().attr('data-tagcategoryid');
        this.filterParams.tagCategoryIds = this.$form.last().attr('data-tagcategoryids');
        this.filterParams.hasDiscount = this.$form.attr('data-hasdiscount');

        this.$filter && (this.filterParams = functions.getFormData(this.$filter));
        
        this.$form.on('submit', e => {
            const $target = $(e.target);
            e.preventDefault();

            this.isHome = $target.attr('data-ishome') || this.isHome;
            
            if(this.isHome) {
                this.params.objectGroupId = $target.attr('data-objectgroupid');
                this.params.countryId = this.params.destination = $target.attr('data-countryid');
                this.params.perPage = $target.attr('data-perpage') || this.defaults.perPage;
                this.params.tagCategoryId = $target.attr('data-tagcategoryid') || '';
            }

            this.params = $.extend({}, this.defaults, functions.getFormData($target), this.$filter && functions.getFormData(this.$filter));
            this.params._page = this.defaults._page;

            if(this.isHome) {
                this.defaults.tagCategoryIds = '';
                this.params.objectGroupId = $target.attr('data-objectgroupid');
                this.params.tagCategoryId = $target.attr('data-tagcategoryid');
                this.params.tagCategoryIds = $target.attr('data-tagcategoryids');
                this.params.hasDiscount = $target.attr('data-hasdiscount');

                this.params = functions.cleanParams(this.params);
                Object.keys(this.params).forEach(key => {
                    if (!this.params[key] || this.params[key] == this.defaults[key]) delete this.params[key];
                });

                
                location = $target.attr('data-listurl') + '#' + $.param(this.params);
            } else {

                Object.keys(this.params).forEach(key => {
                    if (!this.params[key] || this.params[key] == this.defaults[key]) delete this.params[key];
                });

                functions.setUrlData(this.params, true, true, this.defaults);
            }

        });

        this.$linkedId = $('[name="linkedId"]');
        this.$shipId = $('[name="shipId"]');
        this.shipConnections = JSON.parse(this.$form.attr('data-ship-connections') || '{}');
        this.linkedConnections = JSON.parse(this.$form.attr('data-place-connections') || '{}');

        // Cache full data-data JSON for both selects so we can restore/filter it
        this._linkedIdAllData = JSON.parse(this.$linkedId.attr('data-data') || '[]');
        this._shipIdAllData   = JSON.parse(this.$shipId.attr('data-data')   || '[]');
        this._selectGuard = false;

        if(! this.isHome) {

            this.getParams();           
            functions.setFormData(this.form, this.params);
            functions.setFormData(this.filter, this.params);
            this.params.guests = $('[name=guests]').val();
            // this.params._page = 1;
            this.find(this.params);
        } else {
            functions.setFormData(this.form, this.defaults);
        }


        // Cache full option lists so we can restore/filter them
        this._linkedIdAllOptions = this.$linkedId.find('option').clone();
        this._shipIdAllOptions   = this.$shipId.find('option').clone();
        this._selectGuard = false;

        const reinitSelect2 = ($el) => {
            // Select2 constructor strips the placeholder attr on first init;
            // retrieve it from the live instance before destroying so reinit
            // gets the correct placeholder text.
            const placeholder = $el.data('select2')?.options?.get('placeholder');
            $el.select2('destroy');
            if (placeholder && placeholder.trim()) $el.attr('placeholder', placeholder);
            new Select2($el[0]);
        };

        const rebuildOptions = ($el, allOptions, allowedIds) => {
            $el.empty();
            allOptions.each((i, opt) => {
                const val = $(opt).val();
                if (!val || !allowedIds || allowedIds.includes(val)) {
                    $el.append($(opt).clone().removeAttr('selected').removeAttr('data-select2-id'));
                }
            });
            reinitSelect2($el);
            $el.val(null).trigger('change');
        };

        this.$linkedId.on('change', e => {
            const id = this.$linkedId.select2('data')[0]?.id || null;
            const shipId = this.$shipId.select2('data')[0]?.id || null;
            if (this._selectGuard || (id && shipId) || shipId) return;

            const connectedIds = id
                ? (this.linkedConnections[id] || []).map(String)
                : null;

            this._selectGuard = true;
            rebuildOptions(this.$shipId, this._shipIdAllOptions, connectedIds);
            this._selectGuard = false;
        });

        this.$shipId.on('change', e => {
            const id = this.$shipId.select2('data')[0]?.id || null;
            const linkedId = this.$linkedId.select2('data')[0]?.id || null;
            
            if (this._selectGuard || (id && linkedId) || linkedId) return;

            const connectedIds = id
                ? (this.shipConnections[id] || []).map(String)
                : null;

            this._selectGuard = true;
            rebuildOptions(this.$linkedId, this._linkedIdAllOptions, connectedIds);
            this._selectGuard = false;
        });

        // this.$filter && functions.setFormData(this.$filter[0], this.params);
        this.$filter.on('change', e => {

            const $currentTarget = $(e.currentTarget);
            this.filterParams = $.extend({}, this.filterParamDefaults, functions.getFormData(this.$filter));
            this.params = functions.getFormData(this.$form);
            const target = $(e.target)[0];
            this.params._page = this.defaults._page;

            // if(target && target.name == 'transportationType') {

                if (target && target.name && ['objectTypeId', 'transportationType'].includes(target.name))
                {
                    $('[name="' + target.name + '"]').each((index, item) => {
                        if(target.id != item.id) {
                            $(item).prop('checked', false);
                        }
                    });
    
                    this.filterParams[target.name] = target.checked ? target.value : this.defaults[target.name];
                }
            // }

            this.getParams();
            this.params = $.extend({}, this.defaults, this.params, this.filterParams);
            this.params._page = this.defaults._page;

            Object.keys(this.params).forEach(key => {
                if (!this.params[key] || this.params[key] == this.defaults[key]) delete this.params[key];
            });
            
            functions.setUrlData(this.params, true, true, list.defaults);
        });

        if ( this.isHome ) {
            return;
        }


        $('.ms-clear').on('click', e => {
            e.preventDefault();
            e.stopPropagation();
            this.params.destination = '';
            $(this.form.destination).val('').trigger('change');
        });

        $('[name="tagCategoryId"]').on('change', e => {
            this.params._page = this.defaults._page;
            // this.getParams();
            this.setTagCategoryId();
            // this.find(this.params);

            // functions.setUrlData(this.params, true, true);
        });
        $('[name="hasDiscount"]').on('change', e => {
            this.params._page = this.defaults._page;
            this.getParams();
            this.params.hasDiscount = e.currentTarget.checked ? $(e.currentTarget).val() : null;
            Object.keys(this.params).forEach(key => {
                if (!this.params[key] || this.params[key] == this.defaults[key]) delete this.params[key];
            });
            functions.setUrlData(this.params, true, true, list.defaults);
        });

        $(window).on('hashchange', e => {
            this.getParams();
            this.setTagCategoryId();
            this.stopChangeEvents = true;

            // functions.scrollToElement(this.$listItems, 100);
            this.find(this.params);
            this.stopChangeEvents = false;
        });
    },
    getParams() {      
        this.params = list.getParams(this.params, this.defaults, this.filterParams);

        if(this.params.arrivalDateFrom) {
            
            let dateFrom = new Date(this.params.arrivalDateFrom);
            let month = dateFrom.getMonth() + 1;
            
            let lastDateOfMonth = new Date(dateFrom.getFullYear(), month, 0);
            this.params.arrivalDateTo = lastDateOfMonth.getFullYear() + '-' + (lastDateOfMonth.getMonth() + 1) + '-' + lastDateOfMonth.getDate();
        }
    },
    setTagCategoryId() {
        let tagCategoryIds = [];
        $('[name="tagCategoryId"]').each((index, target) => {
            const $target = $(target);
            if($target[0].checked) {
                tagCategoryIds.push($target.val());
            }
        });
        this.params.tagCategoryId = tagCategoryIds.join(",");
    },
    find(params) {
        list.find(params).then((response) => {
            list.findDone(response);

            $('[data-page]').on('click', e => {
                e.preventDefault();
                let page = +$(e.currentTarget).attr('data-page');
                if (page != this.params._page) this.params._page = page;
                
                functions.setUrlData(this.params, true, false, this.defaults);
            });
        
            this.$sortBy = $('[name="sortBy"]');
            this.sortBy = this.$sortBy[0] ? this.$sortBy[0] : null;
    
            if(this.sortBy && this.params.sortBy) {
                this.$sortBy.each((index, elem) => {
                    if(elem.type === 'checkbox') {
                        elem.checked = elem.value === this.params.sortBy;
                    } else if(elem.type === 'select-one') {
                        $(elem).val(this.params.sortBy);
                    }
                });
            }

            this.$sortBy.on('change', e => {

                let data = functions.getFormData($(e.currentTarget));
                data.sortBy = data.sortBy ? data.sortBy : '11:DESC';
                this.params = $.extend(this.params, this.getParams(), data);
                functions.setUrlData(this.params, true, true, this.defaults);
            });
            // LOZAD
            window.observer.observe();
        });
    },

};